export enum ChangeType {
    FEATURE = 'FEATURE',
    BUG = 'BUG',
}